import { useState } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { colors } from "../styles/theme";

// Обязательный чекбокс согласия на обработку ПД. name="consent".
// Кастомный квадратик (рамка + красная галка) — аккуратно смотрится на тёмном/стекле.
// dark — светлый текст (для тёмного фона: glass-форма, форма на фото).
export default function ConsentCheckbox({ error, onChange, dark = false, style }) {
  const [checked, setChecked] = useState(false);
  const textColor = dark ? "#c7ccd3" : "#9aa2ac";
  const linkColor = dark ? "#fff" : colors.text;

  const boxBorder = error ? colors.red : dark ? "rgba(255,255,255,.4)" : "#cbd0d7";

  const handle = (e) => {
    setChecked(e.target.checked);
    if (onChange) onChange(e);
  };

  return (
    <div style={style}>
      <label style={{ display: "flex", alignItems: "flex-start", gap: 10, cursor: "pointer", fontSize: 13, lineHeight: 1.5, color: textColor }}>
        {/* скрытый нативный input — держит name/значение для FormData */}
        <input type="checkbox" name="consent" checked={checked} onChange={handle} style={{ position: "absolute", opacity: 0, width: 0, height: 0 }} />
        {/* кастомный квадратик */}
        <span
          aria-hidden
          style={{
            flex: "none",
            width: 18,
            height: 18,
            marginTop: 1,
            borderRadius: 5,
            border: `1.5px solid ${checked ? colors.red : boxBorder}`,
            background: checked ? colors.red : dark ? "rgba(255,255,255,.06)" : "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "background .15s, border-color .15s",
          }}
        >
          {checked && <Check size={13} color="#fff" strokeWidth={3} />}
        </span>
        <span>
          Я согласен на обработку персональных данных и принимаю{" "}
          <Link
            to="/privacy-policy"
            target="_blank"
            style={{ color: linkColor, textDecoration: "underline" }}
            onClick={(e) => e.stopPropagation()}
          >
            политику конфиденциальности
          </Link>
          .
        </span>
      </label>
      {error && <div style={{ fontSize: 12, color: dark ? "#ff9098" : colors.red, marginTop: 5 }}>{error}</div>}
    </div>
  );
}
